import React, { createContext, useState, ReactNode, useContext } from 'react'

interface BillingDropdownContextProps {
  selectedDoctorId: number | undefined
  setSelectedDoctorId: (id: number | undefined) => void
}

const BillingDropdownContext = createContext<BillingDropdownContextProps | undefined>(undefined)

export const BillingDropdownProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedDoctorId, setSelectedDoctorId] = useState<number | undefined>(undefined)

  return (
    <BillingDropdownContext.Provider value={{ selectedDoctorId, setSelectedDoctorId }}>
      {children}
    </BillingDropdownContext.Provider>
  )
}

export const useBillingDropdown = (): BillingDropdownContextProps => {
  const context = useContext(BillingDropdownContext)
  if (!context) throw new Error('useBillingDropdown must be used within a BillingDropdownProvider')
  return context
}
